// src/shared/docNumber.js — „кой номер ще получи" най-горе в нов документ.
//
// Макс (19.10.2026): при фактурите се вижда („➜ Ще бъде издадена фактура
// № …"), при протоколите — не. Тук е общото за всички протоколи (стари и
// бъдещи видове): номерът идва от сървъра (GET <път>/next-number), от
// СЪЩАТА функция, която го дава при записа — екранът не смята свой.
// Окончателният номер се дава при „Запази" (броячът не прескача и не дава
// дупки); ако междувременно е записан друг протокол, новият взема следващия.
//
// apiPath — '/protocols', '/dividends' …; label — „Новият протокол",
// „Новото решение"; existing — отвореният документ (с id) или копие (без id).

import { el } from './dom.js';
import { api } from './api.js';
import { state } from './state.js';

export function numberLine(apiPath, label, existing) {
  const p = el('p', { class: 'doc-number-line', 'aria-live': 'polite' });
  if (existing && existing.id) {
    p.textContent = 'Номер: № ' + (existing.number || '—');
    return p;
  }
  const companyId = (existing && existing.company_id) || state().activeCompany;
  p.textContent = '➜ ' + label + ' ще получи следващия свободен номер.';
  if (!companyId) return p;
  api(apiPath + '/next-number?company_id=' + encodeURIComponent(companyId))
    .then((r) => { if (r && r.number) p.textContent = '➜ ' + label + ' ще получи № ' + r.number + ' (дава се окончателно при „Запази“).'; })
    .catch(() => {});
  return p;
}
